<template>
<div>
  <h5>{{selectedUser.name}}さんのプロフィール</h5>
  <div v-if="userId==currentUserId">
    <b-form-group label="段級位">
      <b-form-select v-model="selectedUser.kyu" :options="kyuOptions" style="width:auto"></b-form-select>
      <label for="inline-form-input-kyu" class="my-auto">級</label>
      <b-form-select v-model="selectedUser.dan" :options="danOptions" style="width:auto"></b-form-select>
      <label for="inline-form-input-dan" class="my-auto">段</label>
    </b-form-group>

    <b-form-group label="プレースタイル">
      <b-form-textarea v-model="selectedUser.playStyle" rows="2" max-rows="8"></b-form-textarea>
    </b-form-group>
    <b-form-group label="現在の目標">
      <b-form-textarea v-model="selectedUser.currentGoal" rows="2" max-rows="8"></b-form-textarea>
    </b-form-group>
    <b-form-group label="練習で意識していること">
      <b-form-textarea v-model="selectedUser.themeInPractice" rows="2" max-rows="8"></b-form-textarea>
    </b-form-group>
    <b-form-group>
      <b-button variant="success" size="sm" @click="updateUserProfile(userId)" class="float-right">更新</b-button>
    </b-form-group>
  </div>
  <div v-else>
    <b-form-group label="段級位">
      <b-form-select v-model="selectedUser.kyu" :options="kyuOptions" style="width:auto" disabled></b-form-select>
      <label for="inline-form-input-kyu" class="my-auto">級</label>
      <b-form-select v-model="selectedUser.dan" :options="danOptions" style="width:auto" disabled></b-form-select>
      <label for="inline-form-input-dan" class="my-auto">段</label>
    </b-form-group>
    <b-form-group label="プレースタイル">
      <b-form-textarea v-model="selectedUser.playStyle" disabled rows="2" max-rows="8"></b-form-textarea>
    </b-form-group>
    <b-form-group label="現在の目標">
      <b-form-textarea v-model="selectedUser.currentGoal" disabled rows="2" max-rows="8"></b-form-textarea>
    </b-form-group>
    <b-form-group label="練習で意識していること">
      <b-form-textarea v-model="selectedUser.themeInPractice" disabled rows="2" max-rows="8"></b-form-textarea>
    </b-form-group>
  </div>
</div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'

export default {
  components: {},
  props: {
    'userId': String,
    'currentUserId': String
  },
  data() {
    return {
      selectedUser: {},
      kyuOptions: [{
        text: "未選択",
        value: ""
      }, "A", "B", "C", "D", "E"],
      danOptions: [{
        text: "未選択",
        value: ""
      }, "10", "9", "8", "7", "6", "5", "4", "3", "2", "初", "無"],
    }
  },
  watch: {
    userId: function() {
      this.selectUser(this.userId)
    }
  },
  created: function() {
    this.database = firebase.database()
    this.user = firebase.auth().currentUser;

    // 空蝉ユーザーの取得
    this.selectUser(this.userId)
  },
  methods: {
    selectUser(userId) {
      var _this = this;
      this.database.ref('users/' + userId).on("value", snapShot => {
        if (snapShot) {
          _this.selectedUser = snapShot.val();
        }
      })
    },
    updateUserProfile(userId) {
      let userProfileRef = this.database.ref('users/' + userId);
      userProfileRef.update(this.selectedUser)
      alert("プロフィールを更新しました。")
    },
  }
}
</script>
